import { ChangeDetectorRef, Component, effect, inject } from '@angular/core';
import { Api } from '../../services/api';
import { Angular2SmartTableModule, LocalDataSource, Settings } from 'angular2-smart-table';
import { toSignal } from '@angular/core/rxjs-interop';
import { Loader } from "../../components/loader/loader";

@Component({
  selector: 'app-materials',
  imports: [Angular2SmartTableModule, Loader],
  templateUrl: './materials.html',
  styleUrl: './materials.css',
})
export class Materials {
  private readonly api = inject(Api);
  private readonly cdr = inject(ChangeDetectorRef);
  protected readonly data = toSignal<Material[] | null>(this.api.getMaterials(), { initialValue: null });
  protected readonly source = new LocalDataSource();

  constructor() {
    effect(() => {
      this.source.load(this.data() ?? []);
      queueMicrotask(() => this.cdr.detectChanges());
    });
  }

  settings: Settings = {
    actions: false,
    columns: {
      type: { title: 'Type' },
      id: { title: 'Id' },
      name: { title: 'Crop' },
      density: { title: 'Density' },
      description: { title: 'Description' },
    },
  };
}
